module.exports = __webpack_public_path__ + "img/glcdw-banner-pic.4c2b2c21.png";